import { lazy } from 'react'

export const LazyQRCodeCanvas = lazy(() =>
  import('qrcode.react').then(mod => ({ default: mod.QRCodeCanvas })),
)
